import { Input } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useDebounce } from '@/hooks/useDebounce';
import { cn } from '@/lib/utils';

const { Search } = Input;

interface SearchBarProps {
  placeholder?: string;
  onSearch: (keyword: string) => void;
  debounceMs?: number;
  className?: string;
  allowClear?: boolean;
  loading?: boolean;
}

export function SearchBar({
  placeholder = '搜索...',
  onSearch,
  debounceMs = 300,
  className,
  allowClear = true,
  loading = false,
}: SearchBarProps) {
  const [keyword, setKeyword] = useState('');
  const debouncedKeyword = useDebounce(keyword, debounceMs);
  const lastSearchedRef = useRef('');

  // 变更时自动搜索（debounce）
  useEffect(() => {
    if (debouncedKeyword !== lastSearchedRef.current) {
      onSearch(debouncedKeyword);
      lastSearchedRef.current = debouncedKeyword;
    }
  }, [debouncedKeyword, onSearch]);

  // 直接搜索（点击搜索按钮或按 Enter）
  const handleSearch = (value: string) => {
    if (value !== lastSearchedRef.current) {
      onSearch(value);
      lastSearchedRef.current = value;
    }
  };

  return (
    <Search
      placeholder={placeholder}
      value={keyword}
      onChange={(e) => setKeyword(e.target.value)}
      onSearch={handleSearch}
      allowClear={allowClear}
      loading={loading}
      className={cn('flex-1', className)}
      style={{
        maxWidth: '100%',
      }}
    />
  );
}
